/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    import IStompSubscription = Application.Services.IStompSubscription;

    export class ThumbnailRetriever {
        public thumbnail: { data: string, url: string, failedThumbnail: boolean } = {
            data: undefined,
            url: undefined,
            failedThumbnail: false,
        };
        private thumbnailSubscription: IStompSubscription;
        private callback: (data: string, url: string, failedThumbnail: boolean) => void;
        
        constructor(
            private stompService: Services.StompService,
            private $timeout: angular.ITimeoutService,
            private blockId: number,
            ) {
            this.initThumbnailSubscription();
        }

        public initThumbnailSubscription(): void {
            if (!this.thumbnailSubscription) {
                this.thumbnailSubscription = this.stompService.thumbnailSubscribe(this.blockId, (t: { data: string, url: string, failedThumbnail: boolean }) => {
                    this.thumbnail.failedThumbnail = t.failedThumbnail;
                    if (this.callback) {
                        this.callback(t.data, t.url, t.failedThumbnail);
                    }
                });
                if (!this.thumbnailSubscription) {
                    this.$timeout(() => {
                        this.initThumbnailSubscription();
                    }, 400);

                }
            }
        }
        public close(): void {
            if (this.thumbnailSubscription) {
                this.thumbnailSubscription.unsubscribe();
                this.thumbnailSubscription = undefined;
            }
        }

        public onThumbnail(cb: (data: string, url: string, failedThumbnail: boolean) => void) {
            this.callback = cb;
        }

    }

}
